import { Controller } from "@hotwired/stimulus"

// A number of a fixed length (SIRET, RPPS, ADELI…): keeps digits only, so a
// pasted "123 456 789 00012" fits, and counts them against the length.
export default class extends Controller {
  static targets = ["input", "counter"]
  static classes = ["complete"]
  static values = { length: Number, template: String }

  connect () {
    this.update()
  }

  update () {
    const digits = this.inputTarget.value.replace(/\D/g, "").slice(0, this.lengthValue)
    if (digits !== this.inputTarget.value) this.inputTarget.value = digits

    if (!this.hasCounterTarget) return

    this.counterTarget.textContent = this.templateValue
      .replace("%{current}", digits.length)
      .replace("%{length}", this.lengthValue)
    if (this.hasCompleteClass) {
      this.counterTarget.classList.toggle(this.completeClass, digits.length === this.lengthValue)
    }
  }
}
